import React from 'react';

class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Map Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="ll-map-error-boundary">
          <div className="ll-map-error-boundary-content">
            <div className="ll-map-error-boundary-icon">⚠️</div>
            <h3>Something went wrong with the map</h3>
            <p>Please try refreshing the page or switching to Google Maps.</p>
            <button
              className="ll-map-error-boundary-button"
              onClick={() => this.setState({ hasError: false, error: null })}
            >
              Try Again
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default MapErrorBoundary;
